<template>
  <div class="down-payment" v-if="product">
    <div class="downpay-strike" v-if="product.strikePriceTag">
      <beast-image :src="ensureImage(product.strikePriceTag.bgImage)" />
      <div class="discount-price-box" :style="{'color': product.strikePriceTag.priceColor}" v-if="product.strikePriceTag.showType == '1'">
        <!-- <div class="discount-icon"></div> -->
        <div class="discount-price">
          <div class="price-item">
            <div class="price-label" :style="{'color': product.strikePriceTag.titleColor}">{{ product.strikePriceTag.title1 }}</div>
            <div class="price-box" :style="{'color': product.strikePriceTag.priceColor}">&yen; <span class="int">{{ product.strikePriceTag.originalPrice?product.strikePriceTag.originalPrice.toFixed():0 }}</span></div>
          </div>
          <div class="price-item min">
            <div class="price-label math"></div>
            <div class="price-box math" :style="{'color': product.strikePriceTag.priceColor}">-</div>
          </div>
          <div class="price-item">
            <div class="price-label" :style="{'color': product.strikePriceTag.titleColor}">{{ product.strikePriceTag.title2 }}</div>
            <div class="price-box" :style="{'color': product.strikePriceTag.priceColor}">&yen; <span class="int">{{ product.strikePriceTag.couponPrice?product.strikePriceTag.couponPrice.toFixed():0 }}</span></div>
          </div>
          <div class="price-item min">
            <div class="price-label math"></div>
            <div class="price-box math" :style="{'color': product.strikePriceTag.priceColor}">=</div>
          </div>
          <div class="price-item last">
            <div class="price-label" :style="{'color': product.strikePriceTag.titleColor}">{{ product.strikePriceTag.title3 }}</div>
            <div class="price-box" :style="{'color': product.strikePriceTag.priceColor}">&yen; <span class="int">{{ product.strikePriceTag.strikePrice?product.strikePriceTag.strikePrice.toFixed():0 }}</span><span v-if="product.variant.spvs.length > 1">起</span></div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="downpay-discount" v-if="product.downPayment && product.downPayment.discount">
      <div class="discount-price-box">
        <div class="discount-icon"></div>
        <div class="discount-price">
          <div class="price-item">
            <div class="price-label">预付定金价</div>
            <div class="price-box">&yen; <span class="int">{{ product.downPayment.discount.downPrice?product.downPayment.discount.downPrice.toFixed():0 }}</span></div>
          </div>
          <div class="price-item min">
            <div class="price-label math"></div>
            <div class="price-box math">-</div>
          </div>
          <div class="price-item">
            <div class="price-label">大额券</div>
            <div class="price-box">&yen; <span class="int">{{ product.downPayment.discount.couponPrice?product.downPayment.discount.couponPrice.toFixed():0 }}</span></div>
          </div>
          <div class="price-item min">
            <div class="price-label math"></div>
            <div class="price-box math">=</div>
          </div>
          <div class="price-item">
            <div class="price-label">预估到手价</div>
            <div class="price-box">&yen; <span class="int">{{ product.downPayment.discount.payPrice?product.downPayment.discount.payPrice.toFixed():0 }}</span><span v-if="product.downPayment.details.length > 1">起</span></div>
          </div>
        </div>
      </div>
      <div class="discount-coupon-box">
        <div class="coupon-items">
          <div class="coupon-item" v-for="item in product.downPayment.discount._coupons" :key="item.id">{{ item.couponName }}</div>
        </div>
        <div class="coupon-get" @click="getCounponAction(product.downPayment.discount.coupons)">
          <div class="get-text">领券</div>
          <div class="get-arrow"></div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { ensure_protocol } from '@beastshop/url-util'
import BeastImage from '@/components/image/'

export default {
  props: ['product'],
  components: {
    BeastImage
  },
  methods: {
    ensureImage (src) {
      return ensure_protocol(src)
    },

    getCounponAction (coupons) {
      this.$selectCoupon(coupons)
      .then(() => {

      })
      .catch(err => {
        
      })
    },

  }
}
</script>




// WEBPACK FOOTER //
// down-payment.vue?2c03641a